import { reflect } from '@effector/reflect';
import { useTranslation } from 'react-i18next';
import { accountTreeModel } from 'entities/account';
import { translated } from 'shared/lib';
import {
	accountsRoute,
	cashdesksRoute,
	accountRoute,
	gameSettingsRoute,
	usersRoute,
	gamesRoute,
	accountsReportRoute,
	shiftsReportRoute,
	jackpotsRoute,
} from 'shared/routing';
import { NavList } from 'shared/ui';
import cls from './admin-layout-nav-list.module.scss';

const AccountancyNavLinkItem = reflect({
	view: NavList.Item,
	bind: {
		to: accountRoute,
		query: accountTreeModel.$singleSelectedNode.map((id) => (id ? { id } : null)),
		children: translated('admin-layout.accountancy'),
		'data-test-id': 'admin-layout-nav-list-accountancy-link',
	},
});

export const AdminLayoutNavList = () => {
	const { t } = useTranslation();

	return (
		<nav className={cls.adminLayoutNavList}>
			<AccountancyNavLinkItem />
			<NavList.Item
				to={accountsRoute}
				data-test-id='admin-layout-nav-list-accounts-link'
			>
				{t('admin-layout.accounts')}
			</NavList.Item>
			<NavList.Item
				to={cashdesksRoute}
				data-test-id='admin-layout-nav-list-cashdesks-link'
			>
				{t('admin-layout.cashdesks')}
			</NavList.Item>
			<NavList.Item
				to={usersRoute}
				data-test-id='admin-layout-nav-list-users-link'
			>
				{t('admin-layout.users')}
			</NavList.Item>
			<NavList.Item
				to={gamesRoute}
				data-test-id='admin-layout-nav-list-games-link'
			>
				{t('admin-layout.games')}
			</NavList.Item>
			<NavList.Item
				to={gameSettingsRoute}
				data-test-id='admin-layout-nav-list-game-settings-link'
			>
				{t('admin-layout.game-settings')}
			</NavList.Item>
			<NavList.Item
				to={jackpotsRoute}
				data-test-id='admin-layout-nav-list-jackpots-link'
			>
				{t('admin-layout.jackpots')}
			</NavList.Item>
			<NavList label={t('admin-layout.reports')}>
				<NavList.Item
					to={accountsReportRoute}
					data-test-id='admin-layout-accounts-report-link'
				>
					{t('admin-layout.accounts-report')}
				</NavList.Item>
				<NavList.Item
					to={shiftsReportRoute}
					data-test-id='admin-layout-shifts-report-link'
				>
					{t('admin-layout.shifts-report')}
				</NavList.Item>
				{/* <NavList.Item to={reviewReportRoute}>{t('admin-layout.review-report')}</NavList.Item>
				<NavList.Item to={dailyReportRoute}>{t('admin-layout.daily-report')}</NavList.Item>
				<NavList.Item to={detailedReportRoute}>{t('admin-layout.detailed-report')}</NavList.Item>
				<NavList.Item to={sessionsReportRoute}>{t('admin-layout.cashiers-report')}</NavList.Item>
				<NavList.Item to={devicesReportRoute}>{t('admin-layout.device-report')}</NavList.Item> */}
			</NavList>
		</nav>
	);
};
